import { Component, OnInit, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UnsubscribeService } from './unsubscribe.service';

@Component({
    selector: 'app-unsubscribe',
    imports: [MatProgressSpinnerModule],
    templateUrl: './unsubscribe.component.html',
    styleUrl: './unsubscribe.component.scss',
})
export class UnsubscribeComponent implements OnInit {
    private unsubscribeService = inject(UnsubscribeService);
    private route = inject(ActivatedRoute);
    private router = inject(Router);

    public email: string | undefined;
    public loading: boolean = true;
    public isHealthRoute: boolean = false;

    ngOnInit() {
        this.loading = true;
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // set flag so we can hide error messaging on /health route
                this.isHealthRoute = event.urlAfterRedirects?.startsWith('/health') || this.router.url.startsWith('/health');
                this.getQueryParam();
            }
        });
    }

    private getQueryParam() {
        this.route.queryParamMap.subscribe((params) => {
            const emailguid = params.get('emailguid');
            if (emailguid) {
                this.unsubscribeService.unsubscribe(emailguid).subscribe({
                    next: (email: string) => {
                        this.email = email;
                        this.loading = false;
                    },
                    error: (error: any) => {
                        this.showError();
                    },
                });
            } else {
                this.showError();
            }
        });
    }

    private showError() {
        this.email = '';
        this.loading = false;
    }
}
